export const MODULE_NAME = 'userBoot';
